import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ListIcon from "@mui/icons-material/List";
import "./tabs.css";

export default function SlidingTabNavigation(props) {
  const { activeIndex, handleTabClick } = props;
  const icons = [<ListIcon />, <VisibilityIcon />, <VisibilityOffIcon />];

  return (
    <div className="button-container">
      <div
        className="background"
        style={{
          transform:
            activeIndex !== null
              ? `translateX(${activeIndex * 100}%)`
              : "translateX(-100%)",
          opacity: activeIndex !== null ? 1 : 0,
        }}
      ></div>
      {["Show", "Hidden"].map((label, index) => (
        <button
          key={index}
          className={`button ${activeIndex === index ? "active" : ""}`}
          onClick={() => handleTabClick(index)}
        >
          <span className="tab-icon">{icons[index]}</span>
          {label}
        </button>
      ))}
    </div>
  );
}
